import * as React from "react";
import { PlaygroundBase } from "../PlaygroundBase";
export function Playground(props) {
    const activeBaseClass = " rj-sport-scoreboard__playground-base--active";
    // Sport data api return property BaseballBase – its value represents which bases are occupied
    // the array depend to BaseballBase property https://github.com/WeKnowSports/SportsDataAPI/wiki/Events-Pull-contract#baseball-1
    // The activeBaseClass is used to change color of the occupied base
    const elementClasses = [
        ["", "", "", ""],
        [activeBaseClass, "", "", ""],
        ["", activeBaseClass, "", ""],
        [activeBaseClass, activeBaseClass, "", ""],
        ["", "", activeBaseClass, ""],
        [activeBaseClass, "", activeBaseClass, ""],
        ["", activeBaseClass, activeBaseClass, ""],
        [activeBaseClass, activeBaseClass, activeBaseClass, ""]
    ];
    return (React.createElement("div", { className: "rj-sport-scoreboard__playground" }, elementClasses[props.base].map((modifier, index) => React.createElement(PlaygroundBase, Object.assign({}, { modifier, index }, { key: `playground-base-${index}` })))));
}
//# sourceMappingURL=Playground.js.map